const restHeaders = {
    headers: { 'content-type': 'application/x-www-form-urlencoded; charset=UTF-8' }
};

enum DrupalFormatTypes {
    html = 'full_html',
    text = 'rich_text'
}

interface ITemplateFields {
    data: {
        html: { textarea: { value: string; format: DrupalFormatTypes } };
    };
}

interface INodeContent {
    title: string;
    language: string;
    seo_title: string;
    seo_canonical: string;
    template_fields: ITemplateFields;
}

interface INode {
    [key: number]: INodeContent;
    rendered: string;
}

const decode = (data: INode = { rendered: '' }) =>
    new DOMParser().parseFromString(data.rendered, 'text/html').documentElement.textContent || '';

export const fetchNode = async (drupalNodeIds: string[], language: string) => {
    const url = `/elc_api/node/${drupalNodeIds.toString()}/all/api`;
    const fetchData = await fetch(url, { ...restHeaders });
    const response: INode = await fetchData.json();
    const entries = Object.entries(response);
    const isFullHTML = (nodeContent: INodeContent) =>
        nodeContent?.template_fields.data?.html.textarea.format === DrupalFormatTypes.html;

    try {
        if (drupalNodeIds.length > 1) {
            const node = entries.find(([_, entry]) =>
                entry?.language?.toLowerCase().startsWith(language)
            ) as [string, INodeContent];

            if (node) {
                const [, nodeContent] = node;
                const data = {
                    rendered: nodeContent?.template_fields?.data?.html?.textarea?.value
                };

                return isFullHTML(nodeContent) ? data.rendered : decode(data);
            }
        }

        const key = entries[0][0] as unknown as number;

        return isFullHTML(response[key]) ? response.rendered : decode(response);
    } catch {
        return '';
    }
};
